"use client";

import { CheckCircle } from "lucide-react";

export interface OtEnquiryConfirmationProps {
  enquiryId?: string;
  clientName?: string;
  email?: string;
  onGoHome?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OtEnquiryConfirmation = ({ enquiryId, clientName, email, onGoHome }: OtEnquiryConfirmationProps) => {
  return (
    <div className="flex flex-col items-center gap-8 py-10 text-center md:py-16">
      {/* Success Icon */}
      <div className="flex size-24 items-center justify-center rounded-full bg-primary-100 md:size-32">
        <CheckCircle className="size-12 text-primary-600 md:size-16" />
      </div>

      {/* Success Message */}
      <div className="flex flex-col gap-4">
        <h2 className="font-crimsonText text-2xl font-bold text-v3-secondary sm:text-3xl md:text-[42px]">
          Thank You for Your Enquiry
        </h2>
        <p className="mx-auto max-w-[600px] font-onest text-base font-normal text-v3-secondary/80 md:text-lg">
          Our Occupational Therapy team will contact you shortly to discuss your
          needs and schedule an appointment.
        </p>
      </div>

      {/* What to Expect */}
      <div className="mx-auto w-full max-w-[500px] rounded-[10px] bg-[#C01610]/5 p-6">
        <h3 className="mb-4 font-onest text-lg font-semibold text-[#C01610]">
          What happens next?
        </h3>
        <ul className="space-y-3 text-left">
          <li className="flex items-start gap-3">
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#C01610] font-onest text-sm font-medium text-white">
              1
            </span>
            <span className="font-onest text-sm text-v3-secondary">
              A member of our team will review your enquiry
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#C01610] font-onest text-sm font-medium text-white">
              2
            </span>
            <span className="font-onest text-sm text-v3-secondary">
              We will contact you within 1-2 business days
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#C01610] font-onest text-sm font-medium text-white">
              3
            </span>
            <span className="font-onest text-sm text-v3-secondary">
              We&apos;ll discuss your needs and book a suitable appointment
            </span>
          </li>
        </ul>
      </div>

      {/* Contact Info */}
      <p className="font-onest text-sm text-v3-secondary/60">
        If you have any urgent queries, please contact us at{" "}
        <a
          href="mailto:info@alexrodriguez.com.au"
          className="font-medium text-[#C01610] hover:underline"
        >
          info@alexrodriguez.com.au
        </a>
      </p>

      {/* Go Home Button */}
      {onGoHome && (
        <button
          type="button"
          onClick={onGoHome}
          className="rounded-[10px] border-2 border-[#C01610] px-8 py-3 font-onest text-base font-medium text-[#C01610] transition-colors hover:bg-[#C01610]/5"
        >
          Go to Homepage
        </button>
      )}
    </div>
  );
};

export default OtEnquiryConfirmation;
